import React, { useState } from "react";

const StrengthTesting = ({ stepData,onSkip, onSubmit }: any) => {

  
  const schema = stepData.ui_schema;
  const options = schema.options;
  const assessId = stepData.assessment_id;
  const stepId = stepData.current_step;

  // ✅ active joint
  const [activeJoint, setActiveJoint] = useState(
    options.joints[0]?.joint_id
  );

  // ✅ store values: joint → position → observation
  const [values, setValues] = useState<any>({});

  const handleChange = (
    jointId: string,
    position: string,
    observationId: string
  ) => {
    setValues((prev: any) => ({
      ...prev,
      [jointId]: {
        ...prev[jointId],
        [position]: observationId,
      },
    }));
  };

  // ✅ prepare payload
  const handleSubmit = (endpoint: string) => {
    const payload: any[] = [];

    Object.keys(values).forEach((jointId) => {
      Object.keys(values[jointId]).forEach((position) => {
        payload.push({
          joint: jointId,
          // position,
          observation: parseFloat(values[jointId][position]),
        });
      });
    });

    console.log("Payload:", payload);
    onSubmit(endpoint, payload);
  };

  return (
    <div>
      <h6>{schema.title}</h6>

      <div className="row">
        
        {/* ✅ LEFT: JOINT LIST */}
        <div className="col-4">
          <ul className="list-group">
            {options.joints.map((joint: any) => (
              <li
                key={joint.joint_id}
                className={`list-group-item ${
                  activeJoint === joint.joint_id ? "active" : ""
                }`}
                style={{ cursor: "pointer" }}
                onClick={() => setActiveJoint(joint.joint_id)}
              >
                {joint.joint_name}
              </li>
            ))}
          </ul>
        </div>

        {/* ✅ RIGHT: POSITIONS TABLE */}
        <div className="col-8">
          <table className="table">
            <thead>
              <tr>
                <th>Position</th>
                <th>Observation</th>
              </tr>
            </thead>

            <tbody>
              {options.positions.map((position: string) => (
                <tr key={position}>
                  <td>{position}</td>

                  <td>
                    <select
                      className="form-control"
                      value={values[activeJoint]?.[position] || ""}
                      onChange={(e) =>
                        handleChange(
                          activeJoint,
                          position,
                          e.target.value
                        )
                      }
                    >
                      <option value="">Select Observation</option>

                      {(options.observations_lookup[position] || []).map(
                        (obs: any) => (
                          <option key={obs.id} value={obs.id}>
                            {obs.text}
                          </option>
                        )
                      )}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ✅ Buttons */}
      <div className="d-flex justify-content-end mt-3">
        {schema.buttons.map((btn: any, i: number) => {
          if (btn.action === "SUBMIT_DATA") {
            return (
              <button
                key={i}
                type="button"
                className="btn btn-primary"
                onClick={() => handleSubmit(btn.endpoint)}
              >
                {btn.label}
              </button>
            );
          }

          if (btn.action === "SUBMIT_EMPTY") {
            return (
              <button
                key={i}
                type="button"
                className="btn btn-secondary me-2"
                // onClick={() => onSubmit(btn.endpoint, [])}
                onClick={() => onSkip(assessId,stepId)}
              >
                {btn.label}
              </button>
            );
          }

          return null;
        })}
      </div>
    </div>
  );
};

export default StrengthTesting;